import Image from 'next/image'
import useUser from '@/hooks/useUser'
import CdnImage from './cdn-image'
import { Skeleton } from './ui/skeleton'
import { cn } from '@/lib/utils'

type Props = {
  className?: string
  username?: string
  /**
   * 呼び出し元が既にアバター URL を持っている場合に渡す。
   * 渡された時点で /api/user へのリクエストを行わない（画像なしの場合は '' を渡す）。
   */
  userImage?: string
  isTeam?: boolean
  isCertified?: boolean
}

export default function Avatar({
  className,
  username = '',
  userImage,
  isTeam,
  // isCertified,
}: Props) {
  // userImage が渡されていれば取得済みとみなし、SWR のキーを null にして fetch を止める
  const shouldFetch = userImage === undefined
  const { user, isLoading } = useUser({
    key: 'username',
    value: shouldFetch ? username : undefined,
  })

  if (isLoading) {
    return (
      <Skeleton
        className={cn(
          'aspect-square rounded-full border border-background/80 bg-ghost-light',
          className,
        )}
      />
    )
  }

  return (
    <div className="relative inline-block">
      <CdnImage
        src={userImage ?? user?.userImage ?? ''}
        alt="avatar"
        className={cn(
          'aspect-square rounded-full border border-background/80 bg-ghost-light object-cover object-center',
          className,
        )}
        width={160}
        height={160}
      />
      {isTeam && (
        <Image
          className="absolute -right-1 bottom-0 w-14 md:-right-2 md:bottom-2 md:w-20"
          src="/images/icons/cer-team.svg"
          width={86}
          height={52}
          alt="Team icon"
        />
      )}
      {/* {!isTeam && isCertified && (
        <Image
          src="/images/icons/cer-sol.svg"
          width={56}
          height={56}
          alt="公認クリエイター"
          className="absolute bottom-0 right-0 h-10 w-10 md:h-14 md:w-14"
        />
      )} */}
    </div>
  )
}
